import * as L from 'leaflet';
export class LeafletMapOptions{
    minZoom: number;
    maxZoom: number;
    zoom: number;
    zoomControl: boolean;
    center: L.LatLng;
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/maps/leaflet-map-options.ts